import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IBrandCampaign } from "./get-brand-campaigns.hook";

interface IResponse {
  campaign: IBrandCampaign;
}

export function useGetBrandCampaignByIdHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/:campaignId",
  });
}
